/* eslint-disable default-param-last */
import {
  SET_CERT_LIST_CONNECTED_TILE_ID,
  SET_CERT_LIST_SIBLINGS_TILE_ID,
  SET_CERT_LIST_SIDEPANEL_VISIBLE,
  SET_CERTS_LIST_SIDEPANEL_LOADING,
  SET_CERTS_LIST_SIDEPANEL_METADATA,
  SET_CERTS_LIST_SIDEPANEL_TEMP_ACTION_STATE,
} from '../types';

const INITIAL_STATE = {
  isSidePanelVisible: false,
  isSidePanelLoading: false,
  sidePanelMetaData: null,
  connectedTileId: null,
  siblingTileId: {
    prev: null,
    next: null,
  },
  tempActionState: false,
};

const sidePanelReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_CERT_LIST_SIDEPANEL_VISIBLE:
      return {
        ...state,
        isSidePanelVisible: action?.payload,
      };

    case SET_CERTS_LIST_SIDEPANEL_LOADING:
      return {
        ...state,
        isSidePanelLoading: action?.payload,
      };

    case SET_CERT_LIST_CONNECTED_TILE_ID:
      return {
        ...state,
        connectedTileId: action?.payload,
      };

    case SET_CERT_LIST_SIBLINGS_TILE_ID:
      return {
        ...state,
        siblingTileId: {
          prev: action?.payload?.prev,
          next: action?.payload?.next,
        },
      };

    case SET_CERTS_LIST_SIDEPANEL_METADATA:
      return {
        ...state,
        sidePanelMetaData: action?.payload,
      };

    // TODO: This is the temp state till the time Carousel is updated for BreadCrumb
    case SET_CERTS_LIST_SIDEPANEL_TEMP_ACTION_STATE:
      return {
        ...state,
        tempActionState: action?.payload,
      };

    default:
      return state;
  }
};

export default sidePanelReducer;
